import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import { BiTargetLock, BiBrain, BiTrendingUp, BiCheckCircle, BiTime, BiUserCheck } from "react-icons/bi";

const ItConsultingMethods = () => {
    const { t } = useTranslations();

    const methods = [
        {
            icon: BiTargetLock,
            title: t("itConsulting_methods_1_title"),
            description: t("itConsulting_methods_1_description"),
            color: "#59bd65",
            features: [
                t("itConsulting_methods_1_features_1"),
                t("itConsulting_methods_1_features_2"),
                t("itConsulting_methods_1_features_3"),
                t("itConsulting_methods_1_features_4")
            ]
        },
        {
            icon: BiBrain,
            title: t("itConsulting_methods_2_title"),
            description: t("itConsulting_methods_2_description"),
            color: "#4CAF50",
            features: [
                t("itConsulting_methods_2_features_1"),
                t("itConsulting_methods_2_features_2"),
                t("itConsulting_methods_2_features_3"),
                t("itConsulting_methods_2_features_4")
            ]
        },
        {
            icon: BiTrendingUp,
            title: t("itConsulting_methods_3_title"),
            description: t("itConsulting_methods_3_description"),
            color: "#45a049",
            features: [
                t("itConsulting_methods_3_features_1"),
                t("itConsulting_methods_3_features_2"),
                t("itConsulting_methods_3_features_3"),
                t("itConsulting_methods_3_features_4")
            ]
        },
        {
            icon: BiCheckCircle,
            title: t("itConsulting_methods_4_title"),
            description: t("itConsulting_methods_4_description"),
            color: "#388E3C",
            features: [
                t("itConsulting_methods_4_features_1"),
                t("itConsulting_methods_4_features_2"),
                t("itConsulting_methods_4_features_3"),
                t("itConsulting_methods_4_features_4")
            ]
        },
        {
            icon: BiTime,
            title: t("itConsulting_methods_5_title"),
            description: t("itConsulting_methods_5_description"),
            color: "#2E7D32",
            features: [
                t("itConsulting_methods_5_features_1"),
                t("itConsulting_methods_5_features_2"),
                t("itConsulting_methods_5_features_3"),
                t("itConsulting_methods_5_features_4")
            ]
        },
        {
            icon: BiUserCheck,
            title: t("itConsulting_methods_6_title"),
            description: t("itConsulting_methods_6_description"),
            color: "#1B5E20",
            features: [
                t("itConsulting_methods_6_features_1"),
                t("itConsulting_methods_6_features_2"),
                t("itConsulting_methods_6_features_3"),
                t("itConsulting_methods_6_features_4")
            ]
        }
    ];

    return (
        <section className="ptb-100 it-consulting-methods">
            {/* Hintergrund-Dekoration */}
            <div className="it-consulting-methods__decoration it-consulting-methods__decoration--top-right"></div>
            <div className="it-consulting-methods__decoration it-consulting-methods__decoration--bottom-left"></div>

            <div className="container">
                <div className="section-title text-center it-consulting-methods__header">
                    <h2 className="it-consulting-methods__title">
                        {t("itConsulting_methods_title")}
                        <span className="it-consulting-methods__title-underline"></span>
                    </h2>
                    <p className="it-consulting-methods__description">
                        {t("itConsulting_methods_description")}
                    </p>
                </div>

                <div className="row">
                    {methods.map((method, index) => {
                        const IconComponent = method.icon;
                        return (
                            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                <div className="it-consulting-methods__card">
                                    {/* Schritt-Nummer */}
                                    <div 
                                        className="it-consulting-methods__step-number"
                                        style={{ 
                                            background: `linear-gradient(135deg, ${method.color}, ${method.color}dd)`,
                                            boxShadow: `0 4px 15px ${method.color}40`
                                        }}
                                    >
                                        {index + 1}
                                    </div>

                                    {/* Icon */}
                                    <div 
                                        className="it-consulting-methods__icon-wrapper"
                                        style={{ 
                                            background: `linear-gradient(135deg, ${method.color}, ${method.color}dd)`,
                                            boxShadow: `0 10px 30px ${method.color}30`
                                        }}
                                    >
                                        <IconComponent className="it-consulting-methods__icon" />
                                    </div>

                                    {/* Titel */}
                                    <h3 className="it-consulting-methods__card-title">
                                        {method.title}
                                    </h3>

                                    {/* Beschreibung */}
                                    <p className="it-consulting-methods__card-description">
                                        {method.description}
                                    </p>

                                    {/* Features */}
                                    <div className="it-consulting-methods__features">
                                        {method.features.map((feature, featureIndex) => (
                                            <div key={featureIndex} className="it-consulting-methods__feature-item">
                                                <div 
                                                    className="it-consulting-methods__feature-dot"
                                                    style={{ background: method.color }}
                                                ></div>
                                                {feature}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ItConsultingMethods;
